import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import PlayerCarouselComponent from './js/player-carousel.component';

ComponentsFactory.getInstance().define('player-carousel', PlayerCarouselComponent);
